import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-circle-left': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 504c-137 0-248-111-248-248s111-248 248-248 248 111 248 248-111 248-248 248zM284.9 360.4l-75.5-72.4h182.6c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24h-182.6l75.5-72.4c9.7-9.3 9.9-24.8 0.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0l-132.7 132.6c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-0.4-34.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-circle-left.js
// module id = 620
// module chunks = 0